// TextLink.tsx
import React from 'react';
import { useTheme } from 'styled-components';

import { Icon } from '../../ui';
import { Text, TextProps } from '../../ui/Text';
import { StyledLink } from './TextLink.style';

export interface TextLinkProps {
  href?: string;
  children: string;
  size: TextProps['size'];
  className?: string;
  target?: '_blank' | '_self' | '_parent' | '_top';
  rel?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  underline?: boolean;
  showIcon?: boolean;
  iconName?: string;
}

export const TextLink: React.FC<TextLinkProps> = ({
  href,
  children,
  className,
  target,
  size,
  rel,
  onClick,
  underline,
  showIcon,
  iconName,
}) => {
  const theme = useTheme();

  return (
    <StyledLink
      href={href}
      className={className}
      target={target}
      rel={rel}
      onClick={onClick}
      underline={underline}
    >
      <Text color={theme.Color.Brand.Primary} size={size}>
        {children}
      </Text>
      {showIcon && iconName && <Icon name={iconName} color={theme.Color.Neutrals.Dark} />}
    </StyledLink>
  );
};
